import {
    Button,
    Card,
    CardContent,
    Grid,
    Tooltip,
    Typography,
} from '@mui/material';
import CustomisedUploadFile from '../uploader/uploadFile';
import { IUploadFile } from '../uploader/IUploadFile';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ExtendedFile, ICardUpload } from './ICardUpload';
import { useRef, useState } from 'react';
import React, { TouchEvent } from 'react';
import { toast } from "react-toastify";

export default function CustomisedCardUpload({
    title,
    comment,
    setFileSelected,
    fileExtensions,
    maxSizeKb,
    rejected,
    checkBySetad,
}: ICardUpload) {
    let hasValueComment = comment?.length! > 0 ? 0 : 1;

    async function handleOnFileChoosed(files: ExtendedFile[]) {
        files.map(async (item: any) => {
            if ((item.size / 1024) > maxSizeKb!) {
                toast.error("فایل سایز عکس مورد نظر بیشتر از اندازه مجاز است.");
                return;
            } else {
                const fileUrlObj = {
                    file: files[0],
                    fileUrl: files[0].preview,
                    fileName: files[0].name,
                    title: title,
                };
                if (files[0].preview !== undefined && fileExtensions?.includes(files[0].type)) {
                    setFileSelected(fileUrlObj);
                } else {
                    toast.warning('نوع فایل بارگذاری شده مجاز نمی باشد');
                }

                return;
            }
        })

    }
    const [openTooltip, setOpenTooltipValue] = useState(null);
    const toggleClick = (index: any) => {
        setOpenTooltipValue(openTooltip === index ? null : index);
    };
    return (
        <Card
            className={`${rejected === true ? 'rejectCardBorderDesign' : rejected === false ? 'acceptCardBorderDesign' : 'cardBorderDesign'} !shadow-none`}
            style={{
                height: '130px',
                marginBottom: '10px',
                background: 'var(--input-bg-color)',
                borderRadius: '8px',
                border: '1px solid var(--border-color)',
            }}
        >
            <CardContent style={{ height: '100%', padding: '9px' }}>
                <Grid container style={{ height: '100%', alignItems: 'center' }}>
                    <Grid item xs={7} >
                        <div
                        // onClick={() => ontouchstart}
                        >
                            <p className="text-sm font-bold text-[#212121] mb-1">
                                <Tooltip
                                    onClose={() => toggleClick(null)}
                                    open={openTooltip === hasValueComment}
                                    placement="bottom-start"
                                    componentsProps={{
                                        tooltip: {
                                            sx: {
                                                width: '165px',
                                                textAlign: 'center',
                                                fontSize: '11px',
                                                // marginRight: '11vh',
                                                // marginLeft: '1vh',
                                            },
                                        },
                                    }}
                                    title={comment + " "}
                                    arrow
                                >
                                    <Button className="!text-sm !font-bold text-[#212121] mb-1 items-center buttonCard primaryColorLight-900"
                                        onClick={() => toggleClick(0)} style={{ background: 'transparent' }} disableTouchRipple>
                                        {title}
                                        <InfoOutlinedIcon
                                            className="primaryColorLight mr-2"
                                            style={{
                                                width: '17px',
                                                height: '17px',
                                            }}
                                        />
                                    </Button>
                                </Tooltip>
                            </p>
                        </div>
                        {/* <p
                            className="primaryColorLight-100"
                            style={{ fontSize: '10px', paddingRight: '10px' }}
                        >
                            {comment + " "}
                        </p> */}
                    </Grid>
                    <Grid item xs={5} style={{ height: '100%' }}>
                        <CustomisedUploadFile
                            onFileChoosed={handleOnFileChoosed}
                            fileExtensions={fileExtensions}
                            maxSizeKb={maxSizeKb}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>

    );
}
